<template>
    <div class="page">
        <ion-grid>
        <ion-row class="search-view">
            <ion-col>
            <ion-row align-items-stretch>
                <ion-col size="12" size-md="2">
                <ion-label>Corporate Name</ion-label>
                <div class="border-line-34 readonly margin-top-10">
                    <ion-input
                    class="form-input"
                    type="text"
                    id="corporateName"
                    @input="corporateName = $event.target.value"
                    :value="corporateName"
                    maxlength="100"
                    readonly = true
                    ></ion-input>
                </div>
                </ion-col>
                <ion-col size="12" size-md="2">
                <ion-label>Branch Name</ion-label>
                <div class="border-line-34 readonly margin-top-10">
                    <ion-input
                    class="form-input"
                    type="text"
                    id="branch"
                    @input="branch = $event.target.value"
                    :value = "branch"
                    maxlength="100"
                    readonly = true
                    ></ion-input>
                </div>
                </ion-col>
                <ion-col size="12" size-md="2">
                <!-- <ion-label>User Mobile Number / Mail ID</ion-label> -->
                 <!-- Remove mail id based on TO DO - 112 -->
                <ion-label>User Mobile Number</ion-label>
                <div class="border-line-34 margin-top-10">
                    <ion-input
                    class="form-input"
                    type="number"
                    id="mobileOrEmail"
                    v-model="mobileOrEmail"
                    @input="mobileOrEmail = $event.target.value"
                    maxlength="100"
                    ></ion-input>
                </div>
                </ion-col>            
                <ion-col size="12" size-md="2">
                <br />
                <ion-button class="btn-search margin-top-10" :disabled = "!readOnlyInd"  @click="searchUserBrancheRelationship">Search</ion-button>
                <ion-button class="btn-clear margin-top-10" :disabled = "!readOnlyInd" @click="clearFields">
                    <ion-icon :icon="refresh"></ion-icon>
                </ion-button>
                </ion-col>
            </ion-row>
            </ion-col>
        </ion-row>
        <ion-row class="row-divider"></ion-row>
        <!--  -->
        <ion-row class="rectangle" v-if="displayInd">
            <ion-col>
            <ion-row align-items-stretch>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                    User ID
                </ion-label>
                <div class="border-line-34 readonly margin-top-10">
                    <ion-input
                    class="form-input"
                    type="text"
                    @input="userId = $event.target.value"
                    :value="userId"
                    readonly = true
                    ></ion-input>
                </div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                    First Name
                </ion-label>
                <div class="border-line-34 readonly margin-top-10">
                    <ion-input
                    class="form-input"
                    type="text"
                    @input="firstName = $event.target.value"
                    :value="firstName"
                    readonly = true
                    ></ion-input>
                </div>
                </ion-col>
                <!-- <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                    Last Name
                </ion-label>
                <div class="border-line-34 readonly margin-top-10">
                    <ion-input
                    class="form-input"
                    type="text"
                    @input="flastName = $event.target.value"
                    :value="lastName"
                    readonly = true
                    ></ion-input>
                </div>
                </ion-col> -->
            <!-- </ion-row> -->
            <!-- <ion-row align-items-stretch> -->
                <ion-col size="12" size-md="3" class="col-padding">
                    <ion-label class="section-item" position="stacked">
                        Mobile Number
                    </ion-label>
                    <div class="border-line-34 readonly margin-top-10">
                        <ion-input
                        class="form-input"
                        type="text"
                        @input="email = $event.target.value"
                        :value="email"
                        :readonly = true
                        ></ion-input>
                    </div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                    <ion-label class="section-item" position="stacked">
                        Tariff Type
                    </ion-label>
                    <div class="border-line-34 margin-top-10">
                            <ion-select
                                class="form-select select-mobile"
                                :value="selectedTariffType"
                                @ionChange="changeTariff($event)"
                                placeholder="Select Tariff"
                            >
                                <ion-select-option
                                v-for="(type, index) in tariffTypes"
                                :value="type.id"
                                :key="index"
                                >{{ type.name }}</ion-select-option>
                            </ion-select>
                            <select class="input-select select-web" v-model="selectedTariffType"  @change="changeTariff($event)" placeholder="Select Tariff">
                                <option
                                v-for="(val, index) in tariffTypes"
                                :key="index"
                                :value="val.id"
                                >{{ val.name }}</option>
                            </select>
                        </div>
                </ion-col>
                <!-- <ion-col size="12" size-md="3" class="col-padding">
                    <ion-label class="section-item" position="stacked">
                        DOB
                    </ion-label>
                    <div class="border-line-34 readonly margin-top-10">
                        <ion-input
                        class="form-input"
                        type="text"
                        @input="dateOfBirth = $event.target.value"
                        :value="dateOfBirth"
                        :readonly = true
                        ></ion-input>
                    </div>
                </ion-col> -->
            </ion-row>
            </ion-col>
        </ion-row>
        <ion-row align-items-stretch v-if="readOnlyInd && userInfo!=null && userRoleId != 3">
            <ion-col size="12" class="col-nopadding ion-text-right">
                <ion-button class="btn-primary" @click="saveUser">{{ isEditing ? 'Update' : 'Associate' }}</ion-button>
                <ion-button class="cancel-btn" @click="cancel">Cancel</ion-button>
                <ion-button class="del-btn" v-if="isEditing" @click="deleteUser()">Delete</ion-button>
            </ion-col>
        </ion-row>
        </ion-grid>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { refresh } from 'ionicons/icons';
import { EVCStationService } from "../../service/evcstation/stations.service";
import { EVCStation, EVCStationStatus } from "../../entity/location/evcstation";
import { migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";

// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import { CorporateService } from "../../service/corporate/corporate.service";
import { flash } from 'ionicons/icons';
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner, alertController } from "@ionic/vue";
import moment from "moment";

export default defineComponent ({
    name: 'associateUserToBranch',
    components: {
        datepicker, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonButton, IonIcon, IonSpinner, alertController, IonSelect, IonSelectOption
    },
    data() {
        return {
            refresh,
            loaderTab: true,
            corporates: [],
            statuses: [],
            corporateId: "",
            corporateName: "",
            branchId: "",
            branch: "",
            mobileOrEmail: "",
            status: "",
            userId: "",
            firstName: "",
            lastName: "",
            mobile: "",
            email: "",
            dateOfBirth: "",
            userInfo: "",
            displayInd: false,
            norecordsfound: true,
            totalRecords: 0,
            pageRecords: 15,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            types: '',
            userType: [],
            readOnlyInd: false,
            selectedTariffType: null,
            mode: "New",
            isEditing: false,
            tariffTypes: [],
            branchId: "",
            relationshipId: "",
            userRoleId: ""
        }
    },
    async mounted() {
        this.userRoleId = localStorage.getItem("user.roleId")
        this.getTariffType();
        let branchInfo = JSON.parse(localStorage.getItem('branchInfo'));
        if(branchInfo) {
            this.fillCorporateDetails(branchInfo);
        }
        
        if (this.$route.params.branchId) {
            let corporateDetails = await new CorporateService().getBranchDetailsById(
            this.$route.params.branchId
            );
            this.fillCorporateDetails(corporateDetails);
        } else {
            // alert('245')
            let getUser = JSON.parse(localStorage.getItem('manageUser'));
            if(getUser) {
                // this.readOnlyInd = true;
                this.isEditing = true;
                // console.log(getUser);
                this.mobileOrEmail = getUser.email;
                this.userInfo = getUser;
                    this.userId = this.userInfo.userId;
                    this.firstName = this.userInfo.name;
                    this.lastName = (this.userInfo.lastName != null ? this.userInfo.lastName : "");
                    this.email = this.userInfo.email;
                    this.selectedTariffType = this.userInfo.tariffType.code;
                    let status = this.userInfo.status.code;
                    this.branchId = this.userInfo.branchId;
                    this.relationshipId = this.userInfo.relationshipId;
                    if(status != 'I') {
                        this.readOnlyInd = true;
                    } else {
                        this.readOnlyInd = false;
                    }
                    this.displayInd = true;
                    this.loaderTab = false;
                // let result = await new CorporateService().viewAssociatedUserInfo(this.mobileOrEmail, this.branchId)
                // console.log(result.data)
                // if(result.data.length != 0) {
                //     this.userInfo = result.data[0];
                //     this.userId = this.userInfo.userId;
                //     this.firstName = this.userInfo.firstName;
                //     this.lastName = (this.userInfo.lastName != null ? this.userInfo.lastName : "");
                //     this.email = this.userInfo.email;
                //     this.selectedTariffType = this.userInfo.tariffType != '' ? this.userInfo.tariffType : this.userType[0]
                //     this.displayInd = true;
                //     this.loaderTab = false;
                // } else {
                //     this.displayInd = false;
                //     this.userInfo = "";
                //     this.userId = "";
                //     this.mobileOrEmail = null;
                //     document.getElementById('mobileOrEmail').value = null
                //     this.firstName = "";
                //     this.lastName = "";
                //     this.dateOfBirth = "";
                //     this.loaderTab = false;
                // }
            } else {
                this.isEditing = false;
                this.readOnlyInd = true;
                this.userInfo = null;
            }
        }
        
    //   let branchInfo = JSON.parse(localStorage.getItem('branchInfo'));
    //   if(branchInfo) {
    //     // let corporateDetails = await new CorporateService().getBranchDetailsById(
    //     //     branchInfo.branchId
    //     //     );
    //         this.fillCorporateDetails(branchInfo);
    //   }
        // if (this.$route.params.branchId) {
        //     let corporateDetails = await new CorporateService().getBranchDetailsById(
        //     this.$route.params.branchId
        //     );
        //     this.fillCorporateDetails(corporateDetails);
        // }
        // this.statuses = await new CorporateService().getUserBranchRelationshipStatus();
        var page = localStorage.getItem('userBranchPage');
        if(page) {
          this.pageNo = Number(page);
        }
        // var search = localStorage.getItem('userBranchSearch');
        // if(search) {
        //   await this.searchUserBrancheRelationship();
        // }
        this.loaderTab = false;
        
    },
    methods: {
        async getTariffType() {
            this.tariffTypes = await new CorporateService().getUserTypes(); 
            if (!this.selectedTariffType) {
                this.selectedTariffType = this.tariffTypes[0]?.id || '';
            }
            // this.selectedTariffType = this.userType[0].code;
        },
        changeTariff(event) {
            this.types = event.target.value;
        },
        viewBranchDetails(corporateId) {
        this.$router.push({
            name: "userBranchRelationshipDetails",
            params: { branchId: this.$route.params.corporateId }
        });
        },
        fillCorporateDetails(corporateInfo) {
            this.corporateName = corporateInfo.corporateName;
            this.branch = corporateInfo.branch;
            this.branchId = corporateInfo.branchId;
        },
        async saveUser() {
            let msg = "Are you sure want to update this user?"
            if(!this.isEditing) {
                msg = "Are you sure want to associate this user?"
            } 
            const res_2 = await alertController.create({
                header: 'Confirm',
                message: msg,
                buttons: [
                    {
                        text: 'NO',
                        role: 'cancel',
                        cssClass: "secondary",
                        handler: res_1 => {
                        }
                    },
                    {
                        text: 'YES',
                        handler: async () => {
                            this.saveUserInfoWithBranch();
                        }
                    }
                ]
            });
            return await res_2.present();    
        // const alert = document.createElement("ion-alert");
        // alert.header = "Confirm";
        // alert.message = "Are you sure want to associate this user?";
        // alert.buttons = [
        //     {
        //     text: "NO",
        //     role: "cancel",
        //     cssClass: "secondary",
        //     handler: () => {}
        //     },
        //     {
        //     text: "YES",
        //     handler: () => {
        //         this.saveUserInfoWithBranch();
        //     }
        //     }
        // ];
        // document.body.appendChild(alert);
        // return alert.present();
        },

        async saveUserInfoWithBranch() {
            if(this.userRoleId != 6) {
                if(!this.isEditing) {
                    try {
                        let result = await new CorporateService().addUserInfoWithBranch(
                        this.branchId,
                        this.userId,
                        this.selectedTariffType
                        )
                        // console.log(result)
                        if(result.data) {
                            new ToastUtils().presentToast("User successfully associated with this branch.");
                            // localStorage.removeItem('branchInfo');
                            localStorage.removeItem('manageUser');
                            this.$router.back();
                        }
                    } catch(err) {
                        let serviceError = migratedTryParseServiceError(err);
                        new ToastUtils().presentToast(serviceError.description);
                        this.loaderTab = false;
                    }
                    
                } else {
                    try {
                        let result = await new CorporateService().saveTariffTypeForUserAssociation(
                        this.branchId,
                        this.userId,
                        this.selectedTariffType,
                        this.relationshipId
                        )
                        // alert("Update successfully");
                        this.$router.back();
                    } catch(err) {
                        let serviceError = migratedTryParseServiceError(err);
                        new ToastUtils().presentToast(serviceError.description);
                        this.loaderTab = false;
                    }
                    
                }
            } else {
                new ToastUtils().presentToast("You can not add or update the user's details");
            }

            
            
        },

        async deleteUser() {
            const alert = await alertController.create({
                header: "Confirm",
                message: "Are you sure you want to remove this user?",
                buttons: [
                {
                    text: "NO",
                    role: "cancel",
                    cssClass: "secondary",
                    handler: () => {
                    }
                },
                {
                    text: "YES",
                    handler: () => {
                    this.deleteUserFromBranch();
                    }
                }
                ]
            });

            await alert.present();
        },

        async deleteUserFromBranch() {
            if(this.userRoleId != 6) {
                try {
                    let result =  await new CorporateService().deleteUserFromBranchRelationship(
                    this.branchId,
                    this.userId,
                    this.relationshipId
                    );
                    if(result.data.length != 0) {
                        this.totalRecords = result.meta.totalrecords;
                        this.userInfo = result.data;
                        (this.pagesList = new PaginationUtils().getPagesList(
                        this.totalRecords,
                        this.pageRecords,
                        this.pageNo
                        )),
                        (this.totalPages = new PaginationUtils().getTotalPages(
                        this.totalRecords,
                        this.pageRecords
                        ));
                        this.norecordsfound = false;
                        this.loaderTab = false;
                        this.$router.push('manageUserToBranch');
                    } else {
                        this.userInfo = "";
                        this.norecordsfound = true;
                        this.loaderTab = false;
                        
                    }
                } catch(err) {
                    let serviceError = migratedTryParseServiceError(err);
                    new ToastUtils().presentToast(serviceError.description);
                    this.loaderTab = false;
                }
            } else {
                new ToastUtils().presentToast("You can not delete the user's details");
            }
            
            
        },

        clearFields() {
            this.displayInd = false;
            this.userId = "";
            document.getElementById("mobileOrEmail").value = null
            this.mobileOrEmail = "";
            this.firstName = "";
            this.lastName = "";
            this.dateOfBirth = "";
            this.norecordsfound = true;
        },

        async searchUserBrancheRelationship() {     
            try {
                this.loaderTab = true;
                if(this.mobileOrEmail == undefined || this.mobileOrEmail == "" || this.mobileOrEmail == null) {
                    new ToastUtils().presentToast("Please enter mobile or email id");
                    this.loaderTab = false;
                } else {
                    let result = await new CorporateService().getUserInfoByMobileOrEmail(this.mobileOrEmail, this.branchId);
                    // this.loaderTab = false;
                    if(result.data.length != 0) {
                        this.userInfo = result.data[0];
                        this.userId = this.userInfo.userId;
                        this.firstName = this.userInfo.firstName;
                        this.lastName = this.userInfo.lastName;
                        // this.mobile = this.userInfo.mobile
                        this.email = this.userInfo.email;
                        this.dateOfBirth = moment(this.userInfo.DOB).format("DD/MMM/YYYY");
                        this.displayInd = true;
                        this.loaderTab = false;
                    } else {
                        this.displayInd = false;
                        this.userInfo = "";
                        this.userId = "";
                        this.mobileOrEmail = null;
                        document.getElementById('mobileOrEmail').value = null
                        this.firstName = "";
                        this.lastName = "";
                        this.dateOfBirth = "";
                        this.loaderTab = false;
                    }
                }
            } catch(error) {
                this.displayInd = false;
                this.userId = "";
                this.mobileOrEmail = null;
                document.getElementById('mobileOrEmail').value = null
                this.firstName = "";
                this.lastName = "";
                this.dateOfBirth = "";
                // new ToastUtils().presentToast(error.response.data.errors[0].detail)
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
                this.loaderTab = false;
            }
        },
        async loadPage(page) {
            localStorage.setItem('userBranchPage', page);
            this.loaderTab = true;
            this.pageNo = page;
            this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                page
            );
            let result = await new CorporateService().corporateAtPageByPaginatedWithSizeMatchingQuery(
                this.pageNo,
                this.pageRecords,
                {
                corporateName: this.corporateName,
                id: this.branchId,
                branch: this.branch
                }
            );
            if(result.data.length != 0) {

                this.totalRecords = result.meta.totalrecords;
                this.corporates = result.data;
                (this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                this.pageNo
                )),
                (this.totalPages = new PaginationUtils().getTotalPages(
                this.totalRecords,
                this.pageRecords
                ));
                this.norecordsfound = false;
                this.loaderTab = false;
            } else {
                this.corporates = [];
                this.norecordsfound = true;
                this.loaderTab = false;
            }
        
        },
        cancel() {
            // this.$root.$emit('branchId',this.$route.params.corporateId)
            //  eventBus.$emit('branchId',this.$route.params.corporateId);
            // localStorage.removeItem('branchInfo');
            // localStorage.removeItem('manageUser');
            this.$router.back('/corporate/manageUserToBranch');
        }
    }
})
</script>

<style scoped>
.readonly {
  background: #f8f8f8 0% 0% no-repeat padding-box;
}
.select-box {
  position: relative;
  max-width: 317px;
  width: 100%;
  display: inline-block;
  margin-right: 16px;
}

.select-box ion-select {
  max-width: 317px;
  width: 100%;
  height: 34px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  border-radius: 4px;
  opacity: 1;
  padding: 12px;
  padding-top: 13px;
  text-align: left;
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  line-height: 26px;
  color: #202020;
}

.select-box .custom-select-placeholder {
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
  position: absolute;
  z-index: 99;
  top: 18px;
  left: 18px;
}

.select-box .custom-select-icon {
  position: absolute;
  z-index: 99;
  top: 6px;
  background: #fff;
  right: 15px;
}

.del-btn{
    height: 52px;
  --background: #ea3c47 0% 0% no-repeat padding-box;
  color: #ffffff;
  opacity: 1;
}

.cancel-btn{
    height: 52px;
  --background: #969191 0% 0% no-repeat padding-box;
  color: #ffffff;
  opacity: 1;
}
</style>